<template>
	<el-container id="biji">
		<div class="zhu" v-loading="bijiloading">
			<div class="biji_header">
				<i class="iconfont">&#xe636;</i>
				我的笔记总数：{{total}}
			</div>
			<div>
				<div class="biji_neirong" v-for="(item,index) in bijiList" :key="item.id">
					<div class="biji_neirong_top">
					<div class="biji_neirong_top_left">{{item.title}}</div>
					<div class="biji_neirong_top_right">{{item.course.title}}</div>
					</div>
					<div :class="item.pneirong?'pneirong biji_neirong_neirong':'biji_neirong_neirong'">
					{{item.content}}
					</div>
					<div>
						<div class="zhankai" @click="expandeClick(index)" v-show="item.zhankai">{{item.zhanshi}}<i :class="item.zhanshi=='收起全文'?'iconfont dao':'iconfont'">&nbsp;&#xe610;</i></div>
					</div>
					<div class="biji_neirong_bottom">
					<div class="biji_neirong_bottom_date">{{item.created_at}}</div>
					<div class="biji_neirong_bottom_caozuo" @click="bianjibiji(item.id)">编辑</div>
					<div class="biji_neirong_bottom_caozuo" @click="delBiji(item.id	,item.course.id,index)">删除</div>
					</div>
				</div>
			</div>
			<div :class="jiazaiCompute('class')" @click="jiazaigengduo()">{{jiazaiCompute('text')}}</div>
			<!-- 笔记对话框 v-loading="bijidialogload"-->
			<el-dialog title="写笔记" :visible.sync="bijidialogVisible" width="40%"  class="taolunduihua" :close-on-click-modal="false">
				<el-input v-model="bijicanshu.title" style="width:100%;margin-bottom:20px;" placeholder="请输入标题"></el-input>
				<el-input v-model="bijicanshu.content" style="width:100%;" placeholder="内容" type="textarea" :rows="12" class="nei"></el-input>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="addBiji()">完成</el-button>
				</span>
			</el-dialog>
			<div class="nodata" v-if="bijiList.length==0">
				<img :src="nodataImg">
				<p>暂无内容</p>
			</div>
		</div>
		
		<div class="fanhui" v-if="fanhui" @click="fanhuidingbu">
			<i class="iconfont">&#xe737;</i>
			
		</div>
	</el-container>
</template>

<script>
export default {
	name: 'biji'
	,data () {
		return {
			bijiList:[]
			,bijiloading:false
			,fanhui:false
			//笔记弹出
			,bijidialogVisible:false
			,ifSrc:this.global.serverSrc+"/web/pdfjs/web/viewer.html?file=",
			bijiId:'',
			params:{
				page:1,
				page_size:5
			}
			,bijicanshu:{
				title:'',
				content:''
			}
			,biji_load_data:true		// 是否可以继续加载更多的笔记
			,total:''
		}
	}
	,mounted:function(){
		// console.log(window);
		window.addEventListener('scroll',this.getScrollPosition,false)
		this.getBijiList()

	}
	,watch:{
		total(){

		}
	}
	,computed:{

	}
	,methods:{
		// 加载更多样式输出
		jiazaiCompute(type){
			let clas,text
			if(this.bijiList.length < this.total){
				clas = 'jiazai'
				text = '加载更多'
			}else if(this.bijiList.length != 0){
				clas = 'jiazai daodi'
				text = '———— 没有更多了 ————'
				this.biji_load_data = false
			}
			if(type == "class"){
				return clas
			}else if(type == "text"){
				return text
			}
		},
		// 加载更多文本输出

		getScrollPosition: function () {
			// 滚动条距顶部距离
			let top = document.documentElement.scrollTop || document.body.scrollTop;
			// console.log(top);
			if(top>200){
				this.fanhui=true
			}else{
				this.fanhui=false
			}
			// 滚动条距左端距离
			// let left = document.documentElement.scrollLeft || document.body.scrollLeft;
		},
		//获取笔记列表
		getBijiList(){
			let serverSrc=this.global.serverSrc
			,qianzui=this.global.qianzui;
			let token=this.$cookies.get("token")
			let query=this.$route.query;
			this.bijiloading = true
			this.$ajax.get(serverSrc + qianzui + "/notes/my_notes",{params:this.params})
			.then(res=>{
				// console.log(res.data.data.list.data);
				this.bijiloading = false
				this.bijiList = [...this.bijiList,...res.data.data.list.data]
				this.total = res.data.data.total
				this.bijiList.forEach(e => {
					this.$set(e,"pneirong",false)
					if(e.content.length>530){
						this.$set(e,"zhanshi",'展开全文')
						e.pneirong=true
						this.$set(e,"zhankai",true)
					}else{
						this.$set(e,"zhankai",false)
					}
				});
				// console.log(res.list.data);
			})
			// console.log(this.bijiList);
		},
		// 文本显示隐藏
		expandeClick(i) {
			// bijidata.list[i]
			if(this.bijiList[i].zhanshi=='展开全文'){
				this.bijiList[i].zhanshi='收起全文',
				this.bijiList[i].pneirong=false
			}else{
				this.bijiList[i].zhanshi='展开全文',
				this.bijiList[i].pneirong=true
			}
        },
		//编辑笔记
		bianjibiji(id){
			this.bijiwancheng=false
			this.bijicanshu.title=''
			this.bijicanshu.content=''
			var token = this.$cookies.get("token"),
			serverSrc = this.global.serverSrc,
			qianzui = this.global.qianzui;
			this.bijiId=id
			this.bijidialogVisible=true
			this.bijicanshu.title=this.bijiList[this.bijiList.findIndex((v)=>v.id==this.bijiId)].title
			this.bijicanshu.content=this.bijiList[this.bijiList.findIndex((v)=>v.id==this.bijiId)].content
			// cole.log();
			// this.$ajax.get(serverSrc + qianzui + "/notes/detail_notes",{params:{notes_id:id}})
			// .then((res)=>{
			// 	// this.bijidialogload = false
			// 	// loading.close()
			// 	this.bijicanshu.title=res.data.data.title
			// 	this.bijicanshu.content=res.data.data.content
			// 	// console.log(res.data);
			// })
		},
		// 请求编辑笔记
		addBiji(){
			var token = this.$cookies.get("token"),
				serverSrc = this.global.serverSrc,
				qianzui = this.global.qianzui;
			let query=this.$route.query;
			var title = this.bijicanshu.title.replace(/^\s*|\s*$/g,"")
			var content = this.bijicanshu.content.replace(/^\s*|\s*$/g,"")
			if(title==''||content==''){
				this.$message({
					showClose: true,
					message: "请输入标题或内容",
					type: 'error'
				})
			}else{
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				this.$ajax.put(serverSrc + qianzui +"/notes/edi_notes",this.$qs.stringify({title: this.bijicanshu.title,content:this.bijicanshu.content,notes_id:this.bijiId}))
				.then((res)=>{
					if(res.data.code!==0){
						this.$message({
							showClose: true,
							message: res.data.message,
							type: 'error'
						})
					}else{
						let query=this.$route.query;
						let lat = query.courseId;
						// this.getBijiList()
						// console.log(this.bijiList.findIndex((v)=>{v.id==bijiId}));
						this.bijiList[this.bijiList.findIndex((v)=>v.id==this.bijiId)].title = this.bijicanshu.title
						this.bijiList[this.bijiList.findIndex((v)=>v.id==this.bijiId)].content = this.bijicanshu.content
						// console.log();
						
						this.$message({
							showClose: true,
							message: "记录成功",
							type: 'success'
						})
						this.bijidialogVisible=false
					}
					loading.close();
				})
			}
		
		},
		// 删除笔记
		delBiji(id,course_id,index){
			var token = this.$cookies.get("token"),
				serverSrc = this.global.serverSrc,
				qianzui = this.global.qianzui;
			// let query=this.$route.query;
			// let lat = query.courseId;
			this.$confirm('此操作将永久删除该笔记, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			// {params:{id:1}}
			this.$ajax.delete(serverSrc + qianzui + "/notes/del_notes",{params:{notes_id:id,course_id:course_id}})
			.then((res)=>{
				// console.log(res.data);
				// return false
				if(res.data.code!==0){
						this.$message({
							showClose: true,
							message: res.data.message,
							type: 'error'
						})
					}else{
						// let query=this.$route.query;
						// let lat = query.courseId;
						// this.bijishuju()
						// this.bijiList.splice(index,1)
						
						this.$message({
							showClose: true,
							message: "已删除",
							type: 'success'
						})
						this.bijiList=[]
						this.params={
							page:1,
							page_size:5
						
						}
						this.getBijiList()
						// this.total--
						// if(this.total<=this.bijiList.length){
							
						// }
						this.bijidialogVisible=false
					}	
					loading.close();
				})
			}).catch(() => {});
		},
		// 加载更多
		jiazaigengduo(){
			if(this.biji_load_data){
				this.params.page++
				this.getBijiList()
			}
		},
		//返回顶部
		fanhuidingbu(){
			if(document.documentElement.scrollTop){
				document.documentElement.scrollTop = 0
			}else{
				document.body.scrollTop = 0
			}
			
			
		}
	}
	,destroyed:function(){
		window.removeEventListener('scroll',this.getScrollPosition,false)
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/biji.vue